__turbopack_context__.v({
  "heroInfoBlock": "HeroInfoBlock-module-scss-module__Er4UuW__heroInfoBlock",
  "heroInfoBlock__imgWrap": "HeroInfoBlock-module-scss-module__Er4UuW__heroInfoBlock__imgWrap",
});
